// src/pages/SupportLoggedOut.tsx
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import loginbg2 from "./Image/login_bg2.jpg"


// Declare global interface for window
declare global {
  interface Window {
    gfn_HidePopup?: () => void;
  }
}

const API_BASE_URL = process.env.REACT_APP_DOCUMENT_LINK;



const SupportLoggedOut: React.FC = () => {

  useEffect(() => {
    // Set background
    document.body.style.backgroundImage = `url(${loginbg2})`;
    document.body.style.backgroundSize = "cover";
    document.body.style.backgroundPosition = "center";
    document.body.style.backgroundRepeat = "no-repeat";

    // Cleanup (VERY IMPORTANT)
    return () => {
      document.body.style.backgroundImage = "";
    };
  }, []);

  const navigate = useNavigate();

  // Simulate VB's Page_Load logic
  useEffect(() => {
    // Clear any client-side storage (simulating session clear)
    sessionStorage.clear();
    sessionStorage.clear();

    // Optional: Call backend logout endpoint
    const callLogout = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}api/logout/`, {
          method: "POST",
          credentials: "include", // For session cookies
        });
        if (!response.ok) {
          console.error("Logout failed on backend");
        }
      } catch (err) {
        console.error("Logout error:", err);
      }
    };
    callLogout();

    // Simulate any VB initialization logic here
    // For example, if there was any VB code in Page_Load, it would go here
  }, []);

  // Simulate the VB fn_Close function
  const handleClose = () => {
    // Check if parent window has gfn_HidePopup (from original VB/JS)
    if (window.parent && typeof window.parent.gfn_HidePopup === "function") {
      window.parent.gfn_HidePopup();
    } else {
      // Fallback: Navigate to login page
      navigate("/SUPPORT/SupportLogin");
    }
  };

  // Inline CSS for all elements (converted from your CSS file)
  const styles = {
    body: {
      // margin: "0 auto",
      // overflowX: "hidden" as const,
      // fontFamily: "'Open Sans', sans-serif",
      // // backgroundColor: "#32495f",
      // minHeight: "100vh",
    },
    loggedOut: {
      display: "block" as const,
      height: "100%",
      width: "100%",
      backgroundColor: "rgba(40, 40, 40, 0.995)",
      position: "fixed" as const,
      zIndex: 9999999999999,
      textAlign: "center" as const,
    },
    loggedOutImage: {
      height: "200px",
      width: "300px",
      display: "block" as const,
      margin: "50px auto",
      marginBottom: "-50px",
      backgroundImage: "url('/Image/logged_out_image.png')",
      backgroundRepeat: "no-repeat" as const,
      backgroundSize: "contain" as const,
      backgroundPosition: "center" as const,
    },
    p: {
      margin: "0",
      padding: "0",
      fontFamily: "Arial, Helvetica, sans-serif",
    },
    titleText: {
      fontFamily: "'Montserrat', sans-serif",
      fontSize: "45px",
      lineHeight: "60px",
      color: "#FFF",
      width: "100%",
      display: "block" as const,
      marginTop: "60px",
      textAlign: "center" as const,
      textShadow: "3px 1px 3px rgba(0, 0, 0, 0.4)",
    },
    stateText: {
      fontFamily: "'Montserrat', sans-serif",
      fontSize: "18px",
      lineHeight: "25px",
      color: "#FFF",
      width: "60%",
      display: "block" as const,
      margin: "50px auto",
      textAlign: "center" as const,
    },
    arText: {
      display: "block" as const,
      marginTop: "20px",
    },
    loCloseBtn: {
      margin: "20px auto" as const,
      height: "70px",
      width: "30%",
      display: "table" as const,
      backgroundColor: "#FFFFFF",
      cursor: "pointer" as const,
    },
    closeBtn: {
      textDecoration: "none" as const,
      outline: "none" as const,
      padding: "0 15px 0 15px",
      margin: "0",
      height: "100%",
      width: "100%",
      fontSize: "20px",
      fontWeight: "bold" as const,
      color: "#ffffff",
      textAlign: "center" as const,
      display: "table-cell" as const,
      verticalAlign: "middle" as const,
      backgroundColor: "#F60",
    },
    mainTopContainer: {
      width: "100%",
      marginTop: "40px",
    },
    header: {
      height: "40px",
      top: "0",
      width: "100vw",
      zIndex: 100,
      position: "fixed" as const,
      backgroundColor: "#333333",
      display: "block" as const,
      padding: "0",
      transition: "all 0.4s ease",
      WebkitTransition: "all 0.4s ease" as const,
      MozTransition: "all 0.4s ease" as const,
      msTransition: "all 0.4s ease" as const,
      OTransition: "all 0.4s ease" as const,
    },
    loginTitleBar: {
      height: "80px",
      backgroundColor: "#0d2346",
      marginTop: "40px",
    },
    sectionContainer: {
      margin: "0 auto",
      height: "auto",
      width: "80%",
      display: "block" as const,
      clear: "both" as const,
      padding: "0",
      overflow: "hidden" as const,
    },
    barSection: {
      margin: "0 auto",
      padding: "0",
      height: "100%",
      overflow: "hidden" as const,
    },
    btLogin: {
      backgroundSize: "contain" as const,
      backgroundRepeat: "no-repeat" as const,
      backgroundPosition: "center" as const,
      padding: "0",
      backgroundImage: "url('/Image/bar_titles_log_in.png')",
    },
    barTitle: {
      margin: "0",
      padding: "0",
      fontFamily: "Arial, Helvetica, sans-serif",
    },
  };

  return (
    <div style={styles.body}>
      <div style={styles.loggedOut}>
        <div style={styles.loggedOutImage}></div>
        <p>
          <span style={styles.titleText}>See you soon</span>
          <span id="ar_text" style={{ ...styles.stateText, ...styles.arText, width:"400px" }}>
            You have successfully logged out.
          </span>
        </p>
        <div id="lo_close_btn" style={styles.loCloseBtn}>
          <button onClick={handleClose} style={styles.closeBtn}>
            Close Message
          </button>
        </div>
      </div>
      <div style={styles.mainTopContainer}>
        <div style={styles.header}></div>
        <div
          id="login_title_bar"
          style={{ ...styles.sectionContainer, ...styles.loginTitleBar }}
        >
          <div id="bt_login" style={{ ...styles.sectionContainer, ...styles.barSection }}>
            <p className="bar_title" style={styles.barTitle}></p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SupportLoggedOut;